import * as types from './actionTypes';

export const setCashier = (status, cashier) => (
    {
        type: types.SET_CASHIER,
        status,
        cashier,
    }
);


// WEBPACK FOOTER //
// ./src/js/store/cashier/actions.js